<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Criar Necessidade de Compra por planilha
        </p>
      </div>
      <div>
        <router-link :to="{ name: 'compras-necessidades' }">
          <div
            style="cursor: pointer; color: #8a8a8a"
            class="row items-center text-weight-bold q-mr-md container-link-voltar"
          >
            <q-icon class="q-mr-sm icon-voltar" name="west" />
            <span class="texto-titulo">Voltar</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="q-ml-md">
      <div class="row col-12 q-mt-md q-gutter-sm">
        <div class="col-md">
          <div class="text-weight-bold text-brand-1">Unidade</div>
          <UnidadeSelect v-model="unidade" />
        </div>
        <div class="col-md">
          <div class="text-weight-bold text-brand-1">Urgência</div>
          <q-select
            :options="options"
            label="Selecione uma Urgencia"
            dense
            outlined
            v-model="urgencia"
            :rules="[(val) => val || 'Campo Obrigatório']"
          />
        </div>
        <div class="col-md">
          <div class="text-weight-bold text-brand-1">Solicitante</div>
          <SelectSolicitante v-model="selected" />
        </div>
        <div class="col-md">
          <div class="text-weight-bold text-brand-1">Centro de Custo</div>
          <SelectCentroCustos v-model="centro" />
        </div>
      </div>

      <div class="row col-12 q-mt-lg">
        <div
          style="font-size: 16px"
          class="q-mb-sm text-brand-1 text-weight-medium"
        >
          <span>Selecione o template com as informações desejadas.</span>
        </div>
        <div class="row col-12 q-gutter-sm items-center">
          <div class="col-4">
            <q-file label="Selecione o Template" outlined dense v-model="file">
              <template v-slot:prepend>
                <q-icon name="attach_file" />
              </template>
            </q-file>
          </div>
          <div class="">
            <q-btn
              style="
                border-radius: 8px;
                background-color: #21324a;
                color: white;
              "
              icon="done"
              no-caps
              label="Enviar Template"
              :disabled="urgencia == '' || selected == '' || centro == ''"
              @click="finalDialog = true"
            />
          </div>
        </div>
      </div>

      <div class="row col-12 q-mt-lg">
        <div
          style="font-size: 16px"
          class="q-mb-sm text-brand-1 text-weight-medium"
        >
          <span
            >Clique no botão abaixo para baixar o template atualizado e como
            utiliza-lo .</span
          >
        </div>
        <div class="row col-12 q-gutter-sm items-center">
          <div>
            <q-btn
              style="
                border-radius: 8px;
                background-color: #304f78;
                color: white;
              "
              icon="done"
              href="https://multpex-docs.s3.amazonaws.com/templates/necessidade-compra/modelo_planilha_subir_necessidade_compra_r4.xlsx"
              no-caps
              label="Baixar Template"
            />
          </div>
        </div>
      </div>
    </div>
    <dialog-info-design
      class="row col-12"
      mensagem="Detalhes Necessidade Compra"
      subMensagem="Preencha os dados abaixo para complementar os dados para auxiliar no processo de compras."
      :showConteudo="true"
      :showCancelar="true"
      :exibir="finalDialog"
      :desabilitarConfirme="
        finalDialogForm.data_aplicacao == '' ||
        finalDialogForm.justificativa_contratacao == ''
      "
      @resultado="enviarTemplate"
    >
      <div>
        <div class="q-ml-sm texto-titulo-input">Data de Aplicação *</div>
        <q-input
          class="input-new-design"
          dense
          outlined
          mask="##/##/####"
          v-model="finalDialogForm.data_aplicacao"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="finalDialogForm.data_aplicacao"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Justificativa Contratação *
        </div>
        <q-input
          v-model="finalDialogForm.justificativa_contratacao"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">Detalhamento Técnico</div>
        <q-input
          v-model="finalDialogForm.detalhamento_tecnico"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Responsabilidades Fornecedores
        </div>
        <q-input
          v-model="finalDialogForm.responsabilidades_fornecedores"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">
          Responsabilidades Contratante
        </div>
        <q-input
          v-model="finalDialogForm.responsabilidades_contratante"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
      <div>
        <div class="q-ml-sm texto-titulo-input">Possíveis Fornecedores</div>
        <q-input
          v-model="finalDialogForm.possiveis_fornecedores"
          dense
          outlined
          type="textarea"
          class="input input-new-design"
        />
      </div>
    </dialog-info-design>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
];

import { computed, onMounted, watch } from "vue";
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import SelectSolicitante from "../components/SelectSolicitante.vue";
import DialogInfoDesign from "../../../../components/DialogInfoDesign.vue";
// import CentroCustoTable from "../components/CentroCustoTable.vue";
// import InfotUpload from "../components/InfotUpload.vue";
import { useRouter } from "vue-router";
import UnidadeSelect from "../../../../components/unidade/UnidadeSelect.vue";
import SelectCentroCustos from "../components/SelectCentroCustos.vue";
export default {
  components: {
    // CentroCustoTable,
    // InfotUpload,
    SelectSolicitante,
    UnidadeSelect,
    SelectCentroCustos,
    DialogInfoDesign,
  },
  setup() {
    const quasar = useQuasar();
    const store = useStore();
    const file = ref("");
    const router = useRouter();
    const finalDialog = ref(false);
    const finalDialogForm = ref({
      data_aplicacao: "",
      detalhamento_tecnico: "",
      responsabilidades_fornecedores: "",
      responsabilidades_contratante: "",
      possiveis_fornecedores: "",
      justificativa_contratacao: "",
    });
    const infos = ref([
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "A coluna código é OPCIONAL, caso o item já exista no seu catálogo, preencha essa informação, caso contrário, deixe em branco",
        icon: "delete",
      },
      {
        name: " Caso a coluna código seja preenchida e o item não exista no catálogo, o item NÃO SERÁ CRIADO, o código será ignorado.",
        icon: "view_column",
      },
      {
        name: "Caso a matricula do responsável não seja encontrada, ela também seráignorada.",
        icon: "do_not_disturb",
      },
      {
        name: "TODOS AS SELEÇÕES (unidade, urgência, solicitante e centro de custo (unidade de controle) são OBRIGATÓRIAS)!",
        icon: "event",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "event",
      },
    ]);
    const activeSlide = ref(false);
    const urgencia = ref("");
    const selected = ref([]);
    const rows = ref([]);
    const centro = ref("");
    const disable = ref(true);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 15,
    });
    const filter = ref("");
    const unidade = ref("");

    const enviarTemplate = async (resultado) => {
      finalDialog.value = false;
      if (resultado) {
        if (file.value == "" || file.value.name.indexOf("xlsx") == -1) {
          quasar.notify({
            message: "O tipo do arquivo não e aceito, ou o campo esta vazio",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }

        try {
          var reader = new FileReader();
          reader.readAsDataURL(file.value);
          reader.onload = async function () {
            try {
              await store.dispatch("compras/upload", {
                planilha: reader.result,
                mapeamento: "necessidade_compra",

                adicional: {
                  vendor_id: unidade.value?.id,
                  solicitante_id: selected.value?.id,
                  cost_center_id: centro.value?.id,
                  tag_id: urgencia.value.value,
                  data_aplicacao:
                    finalDialogForm.value.data_aplicacao == ""
                      ? undefined
                      : finalDialogForm.value.data_aplicacao
                          ?.split("/")
                          ?.reverse()
                          ?.join("-"),
                  detalhamento_tecnico:
                    finalDialogForm.value.detalhamento_tecnico == ""
                      ? undefined
                      : finalDialogForm.value.detalhamento_tecnico,
                  responsabilidades_fornecedores:
                    finalDialogForm.value.responsabilidades_fornecedores == ""
                      ? undefined
                      : finalDialogForm.value.responsabilidades_fornecedores,
                  responsabilidades_contratante:
                    finalDialogForm.value.responsabilidades_contratante == ""
                      ? undefined
                      : finalDialogForm.value.responsabilidades_contratante,
                  possiveis_fornecedores:
                    finalDialogForm.value.possiveis_fornecedores == ""
                      ? undefined
                      : finalDialogForm.value.possiveis_fornecedores,
                  justificativa_contratacao:
                    finalDialogForm.value.justificativa_contratacao == ""
                      ? undefined
                      : finalDialogForm.value.justificativa_contratacao,
                },
              });

              quasar.notify({
                message: "Necessidade criada com sucesso",
                color: "positive",
                actions: [
                  {
                    label: "Fechar",
                    color: "white",
                    handler: () => {
                      /* ... */
                    },
                  },
                ],
              });
              router.push({ name: "compras-necessidades" });
            } catch (error) {
              quasar.notify({
                message: "Erro a o criar necessidade",
                color: "negative",
                actions: [
                  {
                    label: "Fechar",
                    color: "white",
                    handler: () => {
                      /* ... */
                    },
                  },
                ],
              });
            }
          };

          file.value = "";
        } catch (error) {
          console.log(error);

          file.value = "";
        }
      }
    };

    const getSolicitantes = async (page = 1) => {
      try {
        const response = await store.dispatch("compras/getSolicitantes", {
          vendor_id: store.state.org.unidadeData.id,
          search: filter.value,
          page,
        });

        rows.value = response.data.results.data;
        pagination.value.rowsNumber = response.data.results.total;
        pagination.value.page = response.data.results.current_page;
        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      getSolicitantes(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getSolicitantes();
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    onMounted(getSolicitantes);

    const receberCentro = async (value) => {
      centro.value = value;
    };

    return {
      enviarTemplate,
      file,
      options: [
        {
          label: "Normal",
          value: 1,
        },
        {
          label: "Urgente",
          value: 2,
        },
        {
          label: "Máquina Parada",
          value: 3,
        },
      ],
      urgencia,
      rows,
      columns,
      disable,
      pagination,
      filter,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      getSolicitantes,
      selected,
      receberCentro,
      centro,
      activeSlide,
      unidade,
      infos,
      finalDialogForm,
      finalDialog,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
tbody tr td {
  white-space: pre-wrap;
}
.align {
  align-items: center;
}

.cursor {
  cursor: pointer;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
